import Panel from 'components/Panel'
import DisplayExternalHTML from 'components/DisplayExternalHTML'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'
import moment from 'moment'
import InfiniteScroller from '../InfiniteScroller'

const Message = styled.div`
  min-width: 200px;
  max-width: 100%;
  padding: 10px;
  padding-bottom: 20px;
`

const Date = styled.div`
  font-weight: 600;
  margin-bottom: 5px;
  text-align: left;
`

const MessageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
`

const MessageContent = styled.div`
  white-space: normal;
  word-break: break-word;
`

const Bulletin = ({
  height,
  messages,
  totalCount,
  isFetching,
  fetchMoreBulletin
}) => {
  const bulletinIcon = <FontAwesome name="comments" />
  const hasMore = messages.length < totalCount
  const messageList = messages.map((message, index) => {
    return (
      <Message key={`${message.id}-${index}`}>
        <MessageContent>
          <Date>{moment(message.created).format('lll')}:</Date>
          <DisplayExternalHTML message={message.message} />
        </MessageContent>
      </Message>
    )
  })

  return (
    <Panel title="Bulletin" buttons={bulletinIcon} blue height={height}>
      {!isFetching && messages.length === 0 && (
        <div className="no-content">
          There are currently no bulletin board updates
        </div>
      )}

      {messages.length !== 0 && (
        <InfiniteScroller
          height={'260px'}
          dataLength={messages.length}
          next={fetchMoreBulletin}
          hasMore={hasMore}
          loaderMessage="Loading more messages..."
          endMessage={`All ${totalCount} messages are loaded`}
        >
          <MessageContainer>
            {messageList}
          </MessageContainer>
        </InfiniteScroller>
      )}
    </Panel>
  )
}

export default Bulletin
